import { useEffect, useState } from 'react';
import analyzePose from '../services/AnalyzePoseSerivce';
import ColloredTd from '../components/tableComponents/ColloredTd';

const Sample = () => {
  const options = {
    neck: {
      text: '목',
      position: [
        { code: 'NC_PT_00', text: '선택' },
        { code: 'NC_PT_01', text: '뒤로 젖힘' },
        { code: 'NC_PT_02', text: '0도 ~ 10도 굽힘' },
        { code: 'NC_PT_03', text: '10도 ~ 20도 굽힘' },
        { code: 'NC_PT_04', text: '20도 이상 굽힘' },
      ],
      adjust: [
        {
          code: 'NC_AJ_01',
          text: '비틀림',
          option: 'check',
        },
        {
          code: 'NC_AJ_02',
          text: '옆으로 구부림',
          option: 'check',
        },
      ],
    },
    trunk: {
      text: '몸통(허리)',
      pose: [
        { code: 'TR_PS_00', text: '선택' },
        { code: 'TR_PS_01', text: '곧바로 편 자세(서있음)' },
        {
          code: 'TR_PS_02',
          text: '상체를 앞으로 20도 이상 굽힌 자세',
        },
        {
          code: 'TR_PS_03',
          text: '바로 서서 허리를 옆으로 20도 이상 비튼 자세',
        },
        {
          code: 'TR_PS_04',
          text: '상체를 앞으로 굽힌 채 옆으로 비튼 자세',
        },
      ],
      position: [
        { code: 'TR_PT_00', text: '선택' },
        { code: 'TR_PT_01', text: '-20도 이상 뒤로' },
        { code: 'TR_PT_02', text: '20도 ~ 0도 뒤로' },
        { code: 'TR_PT_03', text: '똑바로' },
        { code: 'TR_PT_04', text: '0~20도 굽힘' },
        { code: 'TR_PT_05', text: '20도 ~ 60도 굽힘' },
        { code: 'TR_PT_06', text: '60도 이상 굽힘' },
      ],
      adjust: [
        { code: 'TR_AJ_01', text: '비틀림', option: 'check' },
        {
          code: 'TR_AJ_02',
          text: '옆으로 구부림',
          option: 'check',
        },
      ],
    },
    leg: {
      text: '다리',
      pose: [
        { code: 'LG_PS_00', text: '선택' },
        { code: 'LG_PS_01', text: '앉은 자세' },
        { code: 'LG_PS_02', text: '두 다리를 펴고 선 자세' },
        { code: 'LG_PS_03', text: '한 다리로 선 자세' },
        { code: 'LG_PS_04', text: '두 다리를 구부린 선 자세' },
        { code: 'LG_PS_05', text: '한 다리로 서서 구부린 선 자세' },
        { code: 'LG_PS_06', text: '무릎을 꿇는 자세' },
        { code: 'LG_PS_07', text: '걷기' },
      ],
      position: [
        { code: 'LG_PT_00', text: '선택' },
        { code: 'LG_PT_01', text: '한 다리로 지지' },
        { code: 'LG_PT_02', text: '두 다리로 지지' },
      ],
      adjust: [
        {
          code: 'LG_AJ_00',
          text: '선택',
          option: 'select',
        },
        {
          code: 'LG_AJ_01',
          text: '무릎이 30~60도 구부러질 경사시(앉은자세 제외)',
          option: 'select',
        },
        {
          code: 'LG_AJ_02',
          text: '무릎이 60도 이상 구부러질 시(앉은자세 제외)',
          option: 'select',
        },
        {
          code: 'LG_AJ_03',
          text: '앉은 자세(허리 지지됨)',
          option: 'check',
        },
        {
          code: 'LG_AJ_04',
          text: '앉은 자세(허리 지지 안됨)',
          option: 'check',
        },
      ],
    },
    upperArm: {
      text: '어깨(상완)',
      position: [
        { code: 'UA_PT_00', text: '선택' },
        { code: 'UA_PT_01', text: '-20도 이상 뒤로' },
        {
          code: 'UA_PT_02',
          text: '-20도 뒤로 ~ 20도 앞으로',
        },
        { code: 'UA_PT_03', text: '20~45도 앞으로' },
        { code: 'UA_PT_04', text: '45~90도 앞으로' },
        { code: 'UA_PT_05', text: '90도 이상 위로' },
      ],
      adjust: [
        { code: 'UA_AJ_01', text: '위팔 벌어지거나 회전', option: 'check' },
        { code: 'UA_AJ_02', text: '어깨들림', option: 'check' },
        {
          code: 'UA_AJ_03',
          text: '팔이 지지되거나 몸을 어딘가에 기댐',
          option: 'check',
        },
      ],
    },
    lowerArm: {
      text: '팔(팔꿈치)',
      pose: [
        { code: 'AA_PS_00', text: '선택' },
        { code: 'AA_PS_01', text: '양팔 어깨 아래' },
        { code: 'AA_PS_02', text: '한팔 어깨 위' },
        { code: 'AA_PS_03', text: '양팔 어깨 위' },
      ],
      position: [
        { code: 'LA_PT_00', text: '선택' },
        {
          code: 'LA_PT_01',
          text: '0 ~ 60도(위팔 수직선에서)',
        },
        {
          code: 'LA_PT_02',
          text: '60 ~ 100도(위팔 수직선에서)',
        },
        {
          code: 'LA_PT_03',
          text: '100도 이상(위팔 수직선에서)',
        },
      ],
      adjust: [
        {
          code: 'LA_AJ_01',
          text: '팔이 교차 또는 몸통을 벗어남',
          option: 'check',
        },
      ],
    },
    wrist: {
      text: '손목',
      position: [
        { code: 'WR_PT_00', text: '선택' },
        { code: 'WR_PT_01', text: '15도 이상 들림' },
        { code: 'WR_PT_02', text: '중립' },
        { code: 'WR_PT_03', text: '-15도 아래 ~ 15도 사이' },
        { code: 'WR_PT_04', text: '-15도 이상 꺾임' },
      ],
      adjust: [
        { code: 'WR_AJ_00', text: '선택', option: 'select' },
        {
          code: 'WR_AJ_01',
          text: '손목이 중립에서 반정도 비틀어짐',
          option: 'select',
        },
        { code: 'WR_AJ_02', text: '손목이 완전히 비틀어짐', option: 'select' },
        { code: 'WR_AJ_03', text: '손목이 옆으로 굽혀짐', option: 'check' },
      ],
    },
    weight: {
      text: '무게/하중',
      data: [
        { code: 'WT_01', text: '2kg 미만', option: 'radio' },
        { code: 'WT_02', text: '2 ~ 5kg', option: 'radio' },
        { code: 'WT_03', text: '5 ~ 10kg', option: 'radio' },
        { code: 'WT_04', text: '10 ~ 20kg', option: 'radio' },
        { code: 'WT_05', text: '20kg 이상', option: 'radio' },
      ],
    },
    frequency: {
      text: '빈도/강도',
      data: [
        { code: 'FQ_01', text: '가끔 물건을 들어올림', option: 'radio' },
        { code: 'FQ_02', text: '정적이거나 반복작업을 수행', option: 'radio' },
        {
          code: 'FQ_03',
          text: '갑작스럽게 물건을 들어올리거나 충격을 받음',
          option: 'radio',
        },
      ],
    },
    add: {
      text: '추가사항',
      data: [
        { code: 'AD_01', text: '1분이상 정적자세', option: 'check' },
        { code: 'AD_02', text: '분당  4회 이상 반복', option: 'check' },
        {
          code: 'AD_03',
          text: '동작으로 자세가 급변하거나 불안정한 지지면에서 수행됨',
          option: 'check',
        },
      ],
    },
    handle: {
      text: '손잡이',
      data: [
        { code: 'HD_01', text: '좋음(적절한 손잡이)', option: 'radio' },
        { code: 'HD_02', text: '보통(대용 손잡이)', option: 'radio' },
        {
          code: 'HD_03',
          text: '나쁨(부적절한 손잡이)',
          option: 'radio',
        },
        {
          code: 'HD_04',
          text: '부적절(손잡이 없음)',
          option: 'radio',
        },
      ],
    },
  };

  const [poseInfo, setPoseInfo] = useState({
    neck: {
      position: 'NC_PT_00',
      adjust: {
        check: {
          NC_AJ_01: 'N',
          NC_AJ_02: 'N',
        },
      },
    },
    trunk: {
      pose: 'TR_PS_00',
      position: 'TR_PT_00',
      adjust: {
        check: {
          TR_AJ_01: 'N',
          TR_AJ_02: 'N',
        },
      },
    },
    leg: {
      pose: 'LG_PS_00',
      position: 'LG_PT_00',
      adjust: { select: 'LG_AJ_00', check: { LG_AJ_03: 'N', LG_AJ_04: 'N' } },
    },
    upperArm: {
      position: 'UA_PT_00',
      adjust: {
        check: {
          UA_AJ_01: 'N',
          UA_AJ_02: 'N',
          UA_AJ_03: 'N',
        },
      },
    },
    lowerArm: {
      pose: 'AA_PS_00',
      position: 'LA_PT_00',
      adjust: {
        check: {
          LA_AJ_01: 'N',
        },
      },
    },
    wrist: {
      position: 'WR_AJ_00',
      adjust: {
        select: 'WR_AJ_00',
        check: {
          WR_AJ_03: 'N',
        },
      },
    },
    weight: 'WT_01',
    frequency: 'FQ_01',
    add: {
      AD_01: 'N',
      AD_02: 'N',
      AD_03: 'N',
    },
    handle: 'HD_01',
  });

  const [scores, setScores] = useState({
    owasTrunkScr: null,
    owasLegScr: null,
    owasArmScr: null,
    owasWeightScr: null,
    owasScr: null,
    rulaNeckScr: null,
    rulaTrunkScr: null,
    rulaLegScr: null,
    rulaUpperArmScr: null,
    rulaLowerArmScr: null,
    rulaWristScr: null,
    rulaWristTwistScr: null,
    rulaScr: null,
    rebaNeckScr: null,
    rebaTrunkScr: null,
    rebaLegScr: null,
    rebaUpperArmScr: null,
    rebaLowerArmScr: null,
    rebaWristScr: null,
    rebaScr: null,
  });

  useEffect(() => {
    if (['TR_PS_03', 'TR_PS_04'].includes(poseInfo.trunk.pose)) {
      setPoseInfo({
        ...poseInfo,
        trunk: {
          ...poseInfo.trunk,
          adjust: {
            ...poseInfo.trunk.adjust,
            check: {
              ...poseInfo.trunk.adjust.check,
              TR_AJ_01: 'Y',
            },
          },
        },
      });
    }
  }, [poseInfo.trunk.pose]);

  useEffect(() => {
    if (poseInfo.leg.pose === 'LG_PS_01') {
      setPoseInfo({
        ...poseInfo,
        leg: {
          ...poseInfo.leg,
          adjust: {
            ...poseInfo.leg.adjust,
            check: {
              ...poseInfo.leg.adjust.check,
              LG_AJ_03: 'Y',
            },
          },
        },
      });
    }
  }, [poseInfo.leg.pose]);

  useEffect(() => {
    if (poseInfo.leg.adjust.check.LG_AJ_03 === 'Y') {
      setPoseInfo({
        ...poseInfo,
        leg: {
          ...poseInfo.leg,
          adjust: {
            ...poseInfo.leg.adjust,
            check: {
              ...poseInfo.leg.adjust.check,
              LG_AJ_04: 'N',
            },
          },
        },
      });
    }
  }, [poseInfo.leg.adjust.check.LG_AJ_03]);

  useEffect(() => {
    if (poseInfo.leg.adjust.check.LG_AJ_04 === 'Y') {
      setPoseInfo({
        ...poseInfo,
        leg: {
          ...poseInfo.leg,
          adjust: {
            ...poseInfo.leg.adjust,
            check: {
              ...poseInfo.leg.adjust.check,
              LG_AJ_03: 'N',
            },
          },
        },
      });
    }
  }, [poseInfo.leg.adjust.check.LG_AJ_04]);

  useEffect(() => {
    if (poseInfo.frequency === 'FQ_03') {
      setPoseInfo({
        ...poseInfo,
        add: {
          ...poseInfo.add,
          AD_03: 'Y',
        },
      });
    }
  }, [poseInfo.frequency]);

  useEffect(() => {
    setScores(analyzePose(poseInfo));
  }, [poseInfo]);

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">자세점수계산</h2>
      </div>
      <div className="tbl-wrap">
        <table className="tbl data row scroll divide">
          <colgroup>
            <col style={{ width: '7%' }} />
            <col style={{ width: '17%' }} />
            <col style={{ width: '17%' }} />
            <col style={{ width: '17%' }} />
            <col style={{ width: '17%' }} />
            <col style={{ width: '9%' }} />
            <col style={{ width: '8%' }} />
            <col style={{ width: '8%' }} />
          </colgroup>
          <tbody>
            <tr>
              <th>구분</th>
              <th colSpan={2}>자세 정보</th>
              <th colSpan={2}>부가 정보</th>
              <th className="bg1">OWAS</th>
              <th className="bg1">RULA</th>
              <th className="bg1">REBA</th>
            </tr>
            <tr>
              <th>{options.neck.text}</th>
              <td colSpan={2}>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.neck.position}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        neck: { ...poseInfo.neck, position: e.target.value },
                      });
                    }}
                  >
                    {options.neck.position.map(option => (
                      <option
                        key={option.code}
                        value={option.code}
                        id={option.code}
                      >
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </td>
              <td colSpan={2}>
                <div className="inner-list">
                  {options.neck.adjust
                    .filter(option => option.option === 'check')
                    .map(option => (
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name={option.code}
                          id={option.code}
                          checked={
                            poseInfo.neck.adjust.check[option.code] === 'Y'
                          }
                          onChange={e => {
                            setPoseInfo({
                              ...poseInfo,
                              neck: {
                                ...poseInfo.neck,
                                adjust: {
                                  ...poseInfo.neck.adjust,
                                  check: {
                                    ...poseInfo.neck.adjust.check,
                                    [option.code]:
                                      poseInfo.neck.adjust.check[
                                        option.code
                                      ] === 'Y'
                                        ? 'N'
                                        : 'Y',
                                  },
                                },
                              },
                            });
                          }}
                        />
                        <label
                          htmlFor={option.code}
                          style={{ textAlign: 'left' }}
                        >
                          <span>{option.text}</span>
                        </label>
                      </div>
                    ))}
                </div>
              </td>
              <td rowSpan={2}>{scores.owasTrunkScr}</td>
              <td>{scores.rulaNeckScr}</td>
              <td>{scores.rebaNeckScr}</td>
            </tr>
            <tr>
              <th>{options.trunk.text}</th>
              <td>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.trunk.pose}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        trunk: { ...poseInfo.trunk, pose: e.target.value },
                      });
                    }}
                  >
                    {options.trunk.pose.map(option => (
                      <option
                        key={option.code}
                        value={option.code}
                        id={option.code}
                      >
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </td>
              <td>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.trunk.position}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        trunk: { ...poseInfo.trunk, position: e.target.value },
                      });
                    }}
                  >
                    {options.trunk.position.map(option => (
                      <option
                        key={option.code}
                        value={option.code}
                        id={option.code}
                      >
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </td>
              <td>
                <div className="inner-list">
                  {options.trunk.adjust
                    .filter(option => option.option === 'check')
                    .map(option => (
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name={option.code}
                          id={option.code}
                          checked={
                            poseInfo.trunk.adjust.check[option.code] === 'Y'
                          }
                          onChange={e => {
                            setPoseInfo({
                              ...poseInfo,
                              trunk: {
                                ...poseInfo.trunk,
                                adjust: {
                                  ...poseInfo.trunk.adjust,
                                  check: {
                                    ...poseInfo.trunk.adjust.check,
                                    [option.code]:
                                      poseInfo.trunk.adjust.check[
                                        option.code
                                      ] === 'Y'
                                        ? 'N'
                                        : 'Y',
                                  },
                                },
                              },
                            });
                          }}
                        />
                        <label
                          htmlFor={option.code}
                          style={{ textAlign: 'left' }}
                        >
                          <span>{option.text}</span>
                        </label>
                      </div>
                    ))}
                </div>
              </td>
              <td rowSpan={2}>
                <div className="inner-list">
                  {options.leg.adjust
                    .filter(option => option.option === 'check')
                    .map(option => (
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name={option.code}
                          id={option.code}
                          checked={
                            poseInfo.leg.adjust.check[option.code] === 'Y'
                          }
                          onChange={e => {
                            setPoseInfo({
                              ...poseInfo,
                              leg: {
                                ...poseInfo.leg,
                                adjust: {
                                  ...poseInfo.leg.adjust,
                                  check: {
                                    ...poseInfo.leg.adjust.check,
                                    ...poseInfo.leg.adjust.select,
                                    [option.code]:
                                      poseInfo.leg.adjust.check[option.code] ===
                                      'Y'
                                        ? 'N'
                                        : 'Y',
                                  },
                                },
                              },
                            });
                          }}
                        />
                        <label
                          htmlFor={option.code}
                          style={{ textAlign: 'left' }}
                        >
                          <span>{option.text}</span>
                        </label>
                      </div>
                    ))}
                </div>
              </td>
              <td>{scores.rulaTrunkScr}</td>
              <td>{scores.rebaTrunkScr}</td>
            </tr>
            <tr>
              <th>{options.leg.text}</th>
              <td>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.leg.pose}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        leg: { ...poseInfo.leg, pose: e.target.value },
                      });
                    }}
                  >
                    {options.leg.pose.map(option => (
                      <option
                        key={option.code}
                        value={option.code}
                        id={option.code}
                      >
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </td>
              <td>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.leg.position}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        leg: { ...poseInfo.leg, position: e.target.value },
                      });
                    }}
                  >
                    {options.leg.position.map(option => (
                      <option
                        key={option.code}
                        value={option.code}
                        id={option.code}
                      >
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </td>
              <td>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.leg.adjust.select}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        leg: {
                          ...poseInfo.leg,
                          adjust: {
                            ...poseInfo.leg.adjust,
                            select: e.target.value,
                          },
                        },
                      });
                    }}
                  >
                    {options.leg.adjust
                      .filter(option => option.option === 'select')
                      .map(option => (
                        <option
                          key={option.code}
                          value={option.code}
                          id={option.code}
                        >
                          {option.text}
                        </option>
                      ))}
                  </select>
                </div>
              </td>

              <td>{scores.owasLegScr}</td>
              <td>{scores.rulaLegScr}</td>
              <td>{scores.rebaLegScr}</td>
            </tr>
            <tr>
              <th>{options.upperArm.text}</th>
              <td colSpan={2}>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.upperArm.position}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        upperArm: {
                          ...poseInfo.upperArm,
                          position: e.target.value,
                        },
                      });
                    }}
                  >
                    {options.upperArm.position.map(option => (
                      <option
                        key={option.code}
                        value={option.code}
                        id={option.code}
                      >
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </td>
              <td colSpan={2}>
                <div className="inner-list">
                  {options.upperArm.adjust
                    .filter(option => option.option === 'check')
                    .map(option => (
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name={option.code}
                          id={option.code}
                          checked={
                            poseInfo.upperArm.adjust.check[option.code] === 'Y'
                          }
                          onChange={e => {
                            setPoseInfo({
                              ...poseInfo,
                              upperArm: {
                                ...poseInfo.upperArm,
                                adjust: {
                                  ...poseInfo.upperArm.adjust,
                                  check: {
                                    ...poseInfo.upperArm.adjust.check,
                                    [option.code]:
                                      poseInfo.upperArm.adjust.check[
                                        option.code
                                      ] === 'Y'
                                        ? 'N'
                                        : 'Y',
                                  },
                                },
                              },
                            });
                          }}
                        />
                        <label
                          htmlFor={option.code}
                          style={{ textAlign: 'left' }}
                        >
                          <span>{option.text}</span>
                        </label>
                      </div>
                    ))}
                </div>
              </td>
              <td rowSpan={4}>{scores.owasArmScr}</td>
              <td>{scores.rulaUpperArmScr}</td>
              <td>{scores.rebaUpperArmScr}</td>
            </tr>
            <tr>
              <th>{options.lowerArm.text}</th>
              <td>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.lowerArm.pose}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        lowerArm: {
                          ...poseInfo.lowerArm,
                          pose: e.target.value,
                        },
                      });
                    }}
                  >
                    {options.lowerArm.pose.map(option => (
                      <option
                        key={option.code}
                        value={option.code}
                        id={option.code}
                      >
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </td>
              <td>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.lowerArm.position}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        lowerArm: {
                          ...poseInfo.lowerArm,
                          position: e.target.value,
                        },
                      });
                    }}
                  >
                    {options.lowerArm.position.map(option => (
                      <option
                        key={option.code}
                        value={option.code}
                        id={option.code}
                      >
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </td>
              <td colSpan={2}>
                <div className="inner-list">
                  {options.lowerArm.adjust
                    .filter(option => option.option === 'check')
                    .map(option => (
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name={option.code}
                          id={option.code}
                          checked={
                            poseInfo.lowerArm.adjust.check[option.code] === 'Y'
                          }
                          onChange={e => {
                            setPoseInfo({
                              ...poseInfo,
                              lowerArm: {
                                ...poseInfo.lowerArm,
                                adjust: {
                                  ...poseInfo.lowerArm.adjust,
                                  check: {
                                    ...poseInfo.lowerArm.adjust.check,
                                    [option.code]:
                                      poseInfo.lowerArm.adjust.check[
                                        option.code
                                      ] === 'Y'
                                        ? 'N'
                                        : 'Y',
                                  },
                                },
                              },
                            });
                          }}
                        />
                        <label
                          htmlFor={option.code}
                          style={{ textAlign: 'left' }}
                        >
                          <span>{option.text}</span>
                        </label>
                      </div>
                    ))}
                </div>
              </td>
              <td>{scores.rulaLowerArmScr}</td>
              <td>{scores.rebaLowerArmScr}</td>
            </tr>
            <tr>
              <th>{options.wrist.text}</th>
              <td rowSpan={2} colSpan={2}>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.wrist.position}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        wrist: {
                          ...poseInfo.wrist,
                          position: e.target.value,
                        },
                      });
                    }}
                  >
                    {options.wrist.position.map(option => (
                      <option
                        key={option.code}
                        value={option.code}
                        id={option.code}
                      >
                        {option.text}
                      </option>
                    ))}
                  </select>
                </div>
              </td>
              <td rowSpan={2}>
                <div className="input-group">
                  <select
                    className="form-select md"
                    value={poseInfo.wrist.adjust.select}
                    onChange={e => {
                      setPoseInfo({
                        ...poseInfo,
                        wrist: {
                          ...poseInfo.wrist,
                          adjust: {
                            ...poseInfo.wrist.adjust,
                            select: e.target.value,
                          },
                        },
                      });
                    }}
                  >
                    {options.wrist.adjust
                      .filter(option => option.option === 'select')
                      .map(option => (
                        <option
                          key={option.code}
                          value={option.code}
                          id={option.code}
                        >
                          {option.text}
                        </option>
                      ))}
                  </select>
                </div>
              </td>
              <td rowSpan={2}>
                <div className="inner-list">
                  <div className="inner-list">
                    {options.wrist.adjust
                      .filter(option => option.option === 'check')
                      .map(option => (
                        <div className="form-check">
                          <input
                            type="checkbox"
                            name={option.code}
                            id={option.code}
                            checked={
                              poseInfo.wrist.adjust.check[option.code] === 'Y'
                            }
                            onChange={e => {
                              setPoseInfo({
                                ...poseInfo,
                                wrist: {
                                  ...poseInfo.wrist,
                                  adjust: {
                                    ...poseInfo.wrist.adjust,
                                    check: {
                                      ...poseInfo.wrist.adjust.check,
                                      [option.code]:
                                        poseInfo.wrist.adjust.check[
                                          option.code
                                        ] === 'Y'
                                          ? 'N'
                                          : 'Y',
                                    },
                                  },
                                },
                              });
                            }}
                          />
                          <label
                            htmlFor={option.code}
                            style={{ textAlign: 'left' }}
                          >
                            <span>{option.text}</span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </td>
              <td>{scores.rulaWristScr}</td>
              <td rowSpan={2}>{scores.rebaWristScr}</td>
            </tr>
            <tr>
              <th>손목 비틀림</th>
              <td>{scores.rulaWristTwistScr}</td>
            </tr>
          </tbody>
        </table>
        <table
          className="tbl data row scroll divide"
          style={{ borderTop: '1px solid #fff' }}
        >
          <colgroup>
            <col style={{ width: '25%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '25%' }} />
          </colgroup>
          <tbody>
            <tr>
              <th>무게</th>
              <th>빈도</th>
              <th>손잡이</th>
              <th>추가사항</th>
            </tr>
            <tr>
              <td>
                <div className="inner-list">
                  {options.weight.data
                    .filter(option => option.option === 'radio')
                    .map(option => (
                      <div className="form-check">
                        <input
                          type="radio"
                          name="weight"
                          id={option.code}
                          value={option.code}
                          checked={poseInfo?.weight === option.code}
                          onChange={e => {
                            setPoseInfo({
                              ...poseInfo,
                              weight: e.target.value,
                            });
                          }}
                        />
                        <label
                          htmlFor={option.code}
                          style={{ textAlign: 'left' }}
                        >
                          <span>{option.text}</span>
                        </label>
                      </div>
                    ))}
                </div>
              </td>
              <td>
                <div className="inner-list">
                  {options.frequency.data
                    .filter(option => option.option === 'radio')
                    .map(option => (
                      <div className="form-check">
                        <input
                          type="radio"
                          name="frequency"
                          id={option.code}
                          value={option.code}
                          checked={poseInfo?.frequency === option.code}
                          onChange={e => {
                            setPoseInfo({
                              ...poseInfo,
                              frequency: e.target.value,
                            });
                          }}
                        />
                        <label
                          htmlFor={option.code}
                          style={{ textAlign: 'left' }}
                        >
                          <span>{option.text}</span>
                        </label>
                      </div>
                    ))}
                </div>
              </td>
              <td>
                <div className="inner-list">
                  {options.handle.data
                    .filter(option => option.option === 'radio')
                    .map(option => (
                      <div className="form-check">
                        <input
                          type="radio"
                          name="handle"
                          id={option.code}
                          value={option.code}
                          checked={poseInfo?.handle === option.code}
                          onChange={e => {
                            setPoseInfo({
                              ...poseInfo,
                              handle: e.target.value,
                            });
                          }}
                        />
                        <label
                          htmlFor={option.code}
                          style={{ textAlign: 'left' }}
                        >
                          <span>{option.text}</span>
                        </label>
                      </div>
                    ))}
                </div>
              </td>
              <td>
                <div className="inner-list">
                  {options.add.data
                    .filter(option => option.option === 'check')
                    .map(option => (
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name={option.code}
                          id={option.code}
                          checked={poseInfo.add[option.code] === 'Y'}
                          onChange={e => {
                            setPoseInfo({
                              ...poseInfo,
                              add: {
                                ...poseInfo.add,
                                [option.code]:
                                  poseInfo.add[option.code] === 'Y' ? 'N' : 'Y',
                              },
                            });
                          }}
                        />
                        <label
                          htmlFor={option.code}
                          style={{ textAlign: 'left' }}
                        >
                          <span>{option.text}</span>
                        </label>
                      </div>
                    ))}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table className="tbl data row scroll divide">
          <colgroup>
            <col style={{ width: '75%' }} />
            <col style={{ width: '9%' }} />
            <col style={{ width: '8%' }} />
            <col style={{ width: '8%' }} />
          </colgroup>
          <tbody>
            <tr>
              <th className="bg1">scores</th>
              <ColloredTd scrType="OWAS" scr={scores?.owasScr?.toString()} />
              <ColloredTd scrType="RULA" scr={scores?.rulaScr?.toString()} />
              <ColloredTd scrType="REBA" scr={scores?.rebaScr?.toString()} />
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Sample;
